import { render } from "./FeaturesSection.vue?vue&type=template&id=3f9a1f1a"
const script = {}

import "./FeaturesSection.vue?vue&type=style&index=0&id=3f9a1f1a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__